// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"311dd699","168":"db0f4a27","751":"335db1f6","894":"caf0bfa9"}[chunkId] + ".chunk.css";
};